/** Detect whether strategy JSON matches the consolidated recommendation shape. */
export function isCurrentStrategyShape(strategy) {
	if (!strategy) return false;
	return (
		Array.isArray(strategy.cross_provider_signals) &&
		Array.isArray(strategy.competitors) &&
		Array.isArray(strategy.recommendations?.own_site?.create) &&
		Array.isArray(strategy.recommendations?.own_site?.optimize)
	);
}

/** @param {import('./providerMap').AnalyseProvider | 'all'} activeProvider */
export function matchesProviderImpact(impact, activeProvider) {
	if (activeProvider === "all") return true;
	const key = activeProvider === "openai" ? "chatgpt" : activeProvider;
	return !!impact?.[key];
}

/** @param {Record<string, boolean>} coverage @param {import('./providerMap').AnalyseProvider} provider */
export function coverageKey(provider, coverage) {
	const payloadKey = provider === "openai" ? "chatgpt" : provider;
	if (payloadKey in coverage) return payloadKey;
	if (provider in coverage) return provider;
	return payloadKey;
}

/** @param {{ provider_coverage: Record<string, boolean> }} signal @param {import('./providerMap').AnalyseProvider} provider */
export function hasSignalCoverage(signal, provider) {
	return !!signal.provider_coverage[coverageKey(provider, signal.provider_coverage)];
}

export function humanize(value) {
	if (typeof value !== "string") return "";
	return value.replace(/_/g, " ").replace(/^./, (c) => c.toUpperCase());
}

export function readDesiredOutcome(desiredOutcome) {
	if (!desiredOutcome || typeof desiredOutcome !== "object") return null;
	const primary =
		typeof desiredOutcome.primary === "string" ? desiredOutcome.primary : null;
	const targetState = desiredOutcome.target_state ?? {};
	const targetPosition =
		typeof targetState.target_average_position === "number"
			? targetState.target_average_position
			: null;
	const secondaryGoal =
		typeof targetState.secondary_goal === "string"
			? targetState.secondary_goal
			: null;
	const featureAssociations = Array.isArray(targetState.feature_associations)
		? targetState.feature_associations.filter((v) => typeof v === "string")
		: [];
	if (
		!primary &&
		targetPosition === null &&
		!secondaryGoal &&
		featureAssociations.length === 0
	) {
		return null;
	}
	return { primary, targetPosition, secondaryGoal, featureAssociations };
}

export function opportunityTier(score) {
	if (score >= 70) return "high";
	if (score >= 40) return "medium";
	return "low";
}

export function signalName(signalId, signals) {
	return signals.find((s) => s.id === signalId)?.name ?? signalId;
}
